import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { ReactComponent as Programadas } from "../../../Svgs/topo_programadas.svg";
import { ReactComponent as EmViagem } from "../../../Svgs/topo_em_viagem.svg";
import { ReactComponent as Finalizadas } from "../../../Svgs/topo_finalizadas.svg";
import { ReactComponent as Acumulado } from "../../../Svgs/valor_acumulado.svg";
import { ReactComponent as AcumuladoRisco } from "../../../Svgs/valor_acumulado_em_risco.svg";
import { ReactComponent as Sucesso } from "../../../Svgs/porcentagem_sucesso.svg";
import { ReactComponent as SemNc } from "../../../Svgs/porcentagem_sem_nc.svg";
import { ReactComponent as Tratativas } from "../../../Svgs/porcentagem_tratativas.svg";
import { ReactComponent as Eventos } from "../../../Svgs/porcentagem_eventos.svg";
import { ReactComponent as Cone } from "../../../Svgs/cone.svg";
import { useEffect } from 'react';
import axios from "axios";
import ConeDetalheViagemPopup from './ConeDetalheViagemPopup';
import BasePage from '../../../Components/Base/BasePage';
import { ConeDeRisco } from '../../../Models/Paineis/ConeDeRisco/ConeDeRisco';
import { ConeConfiguracao } from '../../../Models/Paineis/ConeDeRisco/ConeConfiguracao';
let firstLoad: boolean = false;

const ConePage = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentKey, setCurrentKey] = useState<string>('');
  const [dados, setDados] = useState<any>(new ConeDeRisco());
  const [logotipo, setLogotipo] = useState('');
  const [coneConfiguracao, setConeConfiguracao] = useState<any>(new ConeConfiguracao());
  const setFirstLoad = (value: boolean) => firstLoad =  value;
  const [loading, setLoading] = useState(false);
  const [detalheIds, setDetalheIds] = useState('');
  const [detalheNotIds, setDetalheNotIds] = useState('');

  useEffect(() => {
    const inicializa = async () => inicializaAsync();
    inicializa();
  }, []);

  async function inicializaAsync() {
    setLoading(true);
    await loadStyleCone()
    //setTimeout(async () => await loadStyleCone(), 5000); 
    await carregaDadosConeAsync();
    setLoading(false);
  }

  async function loadStyleCone() {
      let page = document.getElementById("main-height");
      if (page!=null) {
        page.setAttribute('style', 'background-color:#fff');
      } 

      //document.getElementsByTagName("body")[0].setAttribute('style', `background-color:#fff !important`);

      let response: any = await axios.get(`coneConfiguracao`);
      if (response.data != null && response.data != "") {
        setConeConfiguracao(response.data);
       
        //if (page!=null && (coneConfiguracao.cor_fundo??'') != '')
        setConfiguracaoPagina();

        for (const [key, value] of Object.entries(response.data)) {
          coneConfiguracao[key] = value;
        }

        console.table(coneConfiguracao);
        if (coneConfiguracao.logotipo!=null)
        {
          setLogotipo(`${axios.defaults.baseURL}../files/${coneConfiguracao.logotipo}`)
        }
        else
        {
          setLogotipo(`${axios.defaults.baseURL}../KronaMaxxiReduzida.png`)
        }

        setColorConeConfiguracao();
      }
  }

  function setConfiguracaoPagina() {
    setTimeout( () =>  {
    //alert(1);
      let centralPage = document.getElementsByClassName("central-page")
      for (let index = 0; index < centralPage.length; index++) {
        centralPage[index]?.setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
      }

      //document.getElementsByClassName("central-page")[1]?.setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
      document.getElementById("main-height")?.setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
      document.getElementsByTagName("body")[0].setAttribute('style', `background-color:${coneConfiguracao.cor_fundo} !important`);
    }, 1000);
  }
    
  function setColorConeConfiguracao()
  {
      for (const [key, value] of Object.entries(coneConfiguracao)) {
          if (value == '' || value == null)
          {
              continue;
          }
          
          let colorClass = `area_${key}`;
          let elements = document.getElementsByClassName(colorClass) as HTMLCollectionOf<HTMLElement>;
          if (elements.length == 0)
          {
              continue;
          }

          Array.prototype.forEach.call(elements,
              function(element: any) {
                setColor(key, element, value);
          });
      }
  }

  function setColor(key: string, element: any, value: {}) {
      if (key == 'cor_fonte_titulo') {
          element.style['color'] = value;
      }

      else if (key == 'cor_fundo') {
          element.style['background-color'] = value;
      }
      else {
          element.style['fill'] = value;
      }
  }

  async function carregaDadosConeAsync() {  
    let response = await axios.get('coneDeRisco');
    for (const [key, value] of Object.entries(response.data)) {
      dados[key] = value;
    }

    carregaEventos(response.data);
  }

  function carregaEventos(coneDados: any) {
    for (const [key, value] of Object.entries(coneDados)) {
      if (key == null || key == '' ||
        (document.getElementsByClassName(key).length == 0 && document.getElementsByName(key).length == 0)) {
        continue;
      }

      var labels = document.querySelectorAll(`.label.${key}`);
      Array.prototype.forEach.call(labels, function (el) {
        el.innerHTML = value as string;
      });

      var percentuais = document.querySelectorAll(`.percentuais.${key}`);
      Array.prototype.forEach.call(percentuais, function (el) {
        el.innerHTML = value as string;
      });

      //if (!firstLoad) {
        var botoes = document.getElementsByClassName(key);
        Array.prototype.forEach.call(botoes, function (el) {
          el.removeEventListener('click', () => abrePopupAsync(key));
          el.addEventListener('click', () => abrePopupAsync(key));
        });
      //  }
    }

    if (!firstLoad) {
      document.getElementById('area-acumulados-risco')?.addEventListener('click', () => abrePopupAsync('acumulado_risco', true));
      document.getElementById('area-sucessos')?.addEventListener('click', () => abrePopupAsync('sucesso', true));
      document.getElementById('area-sem-ncs')?.addEventListener('click', () => abrePopupAsync('sem-nc', true));
      document.getElementById('area-tratativas')?.addEventListener('click', () => abrePopupAsync('tratativa', true));
      document.getElementById('area-eventos')?.addEventListener('click', () => abrePopupAsync('evento', true));
    }

    console.log(dados);
    console.log(dados['tratamento']);
    carregaPercentuais('acumulado', 100, getValueOrDefault(coneConfiguracao['cor_valor_acumulado'], 'rgb(0, 195, 115)'));
    carregaPercentuais('acumulado-em-risco', dados['percentual_acumulado_em_risco'], getValueOrDefault(coneConfiguracao['cor_valor_acumulado_em_risco'], 'rgb(238, 67, 87)'));
    carregaPercentuais('sucesso',  dados['calculo_sucesso'], getValueOrDefault(coneConfiguracao['cor_sucesso_grafico_direita'], 'rgb(250, 192, 45)'));
    carregaPercentuais('sem-nc',  dados['sem_nc'], getValueOrDefault(coneConfiguracao['cor_sem_nc'], 'rgb(67, 187, 231)'));
    carregaPercentuais('tratativa',  dados['tratamento'], getValueOrDefault(coneConfiguracao['cor_tratativa_grafico_direita'], 'rgb(238, 67, 127)'));
    carregaPercentuais('evento',  dados['eventos'], getValueOrDefault(coneConfiguracao['cor_eventos_grafico_direita'], 'rgb(193, 91, 211)'));

    setFirstLoad(true);
  }

  async function abrePopupAsync(key: string, custom: boolean = false) 
  {
    if (isOpen) {
      return;
    }

    let ids_not_in = '';
    let ids = '';

    if (key == null) {
        return null;
    }

    if (!custom) {
      let dadoAnonimo: any = dados;
      let ids = dadoAnonimo[`ids_${key}`];
      if (ids == null || ids == '' || ids == '0') {
        return;
      }
    }

    document.body.style.cursor = "wait";

    if (key == 'sucesso') {
        ids = dados['ids_status_em_viagem'];
        ids_not_in = concat(dados['ids_roubo'], dados['ids_acidente']);
    }
    else if (key == 'sem-nc') {
        ids = dados['ids_total_viagens'];
        ids_not_in = dados['ids_nc'];
    }
    else if (key == 'tratativa') {
        ids = concat(dados['ids_ocorrencias'], dados['ids_cto']);
    }
    else if (key == 'evento') {
        ids = concat(dados['ids_roubo'], dados['ids_acidente']);
    }
    else if (key == 'acumulado_risco') {
        ids = concat(dados['ids_perdas'], dados['ids_cto']);
        ids = concat(ids, dados['ids_ratc']);
        ids = concat(ids, dados['ids_acidente']);
    }
    else {
        ids = dados[`ids_${key}`];
        if (ids == null || ids == '' || ids == '0') {
            return null;
        }

        let regra = dados[`usar_regra_${key}`];
        if (regra != null && regra) {

            let ids_exception = dados['ids_ocorrencias'];
            ids_exception = concat(ids_exception, dados['ids_perdas']);
            ids_exception = concat(ids_exception, dados['ids_cto']);
            ids_exception = concat(ids_exception, dados['ids_ratc']);
            ids_exception = concat(ids_exception, dados['ids_acidente']);

            ids_not_in = ids_exception;
            ids = dados['ids_status_em_viagem'];

            if (dados[`ids_${key}`] == 'total_risco_mais_ocorrencias_menos_status_em_viagem') {
                ids = ids_exception;
                ids_not_in = dados['ids_status_em_viagem'];
            }
        }
    }

    document.body.style.cursor = "wait";

    setDetalheNotIds(ids_not_in);
    setDetalheIds(ids);
    setCurrentKey(key);
    setIsOpen(true);
  }

  function concat(string1: string, string2: string) {
      let string1Invalida = string1 == null || string1 == '';
      let string2Invalida = string2 == null || string2 == '';
      if (string1Invalida && string2Invalida) {
          return '';
      }

      if (string2Invalida) {
          return string1;
      }

      if (string1Invalida) {
          return string2;
      }

      return string1 + ',' + string2;
  }

  function carregaPercentuais(nomeElement: any, length: number, color: string) {
    length = length / 4;

    for (let index = 1; index <= 24; index++) {
      if (index > length) {
        if (document.getElementsByName(`${nomeElement}-${index}`)[0]?.style?.fill == getValueOrDefault(coneConfiguracao['cor_padrao_grafico_direita'], 'rgb(187, 194, 199)')) {
          continue;
        }

        setDocumentStyle(nomeElement, index, getValueOrDefault(coneConfiguracao['cor_padrao_grafico_direita'], 'rgb(187, 194, 199)'));
        continue;
      }

      setDocumentStyle(nomeElement, index, color);
    }
  }

  function setDocumentStyle(nomeElement: string, index: number, color: string)
  {
    if (document.getElementsByName(`${nomeElement}-${index}`)[0] != null) {
      document.getElementsByName(`${nomeElement}-${index}`)[0].style.fill = color;
    }
  }
  
  function closePopup() {
    setCurrentKey('');
    setIsOpen(false);
  }

  function getValueOrDefault(value: string, defaultValue: string)
  {
    if (value == null || value == '')
    {
      return defaultValue;
    }

    return value;
  }
  return (
    <div className="area_cor_fundo">
      <BasePage recursiveEvent={carregaDadosConeAsync}>
        
        <div style={{ left: '-15px', position: 'relative' }}>

          <div className="row col-12 justify-content-center">
            <div id="top-area" className="col-12 justify-content-center">
              <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 justify-content-center">
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"><Programadas /></div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"><EmViagem /></div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6"><Finalizadas /></div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                <img style={{ width: '100%' }} src={logotipo} />
                </div>
              </div>

              <div className="row col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center justify-content-center align-items-end">
                <div id="center-area" className="row col-xl-7 col-lg-10 col-md-12 col-sm-12 col-12">
                  <h5><strong className="col-12 chart-title cor_fonte_titulo">RASTREAMENTO E GERENCIAMENTO DE RISCO</strong></h5>
                  <Cone />
                </div>

                <div className="row col-xl-4 col-lg-2 col-md-12 col-sm-10 col-10 justify-content-center align-items-end" style={{ marginBottom: '40px' }}>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4" id="area-acumulados"><Acumulado /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand " id="area-acumulados-risco"><AcumuladoRisco /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-sucessos"><Sucesso /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-sem-ncs"><SemNc /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-tratativas"><Tratativas /></div>
                  <div className="col-xl-5 col-lg-12 col-md-2 col-sm-4 col-4 cursor-hand" id="area-eventos"><Eventos /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BasePage>

      {isOpen ? <ConeDetalheViagemPopup isOpen={isOpen} onClose={closePopup} currentKey={currentKey} dados={dados} ids={detalheIds} idsNotIn={detalheNotIds} /> : ''}
    </div>
  );
}

export default ConePage;

